import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Redirect } from 'react-router-dom';
import CreateAccountContainer from '../views/create-account/CreateAccountContainer';
import Error from '../ui/Error';
import { RumRoute as Route } from '@datadog/rum-react-integration';
import { steps } from '../data/flow.redux';
import BookContainer from '../views/book/BookContainer';
import CompanyDetailsContainer from '../views/company-details/CompanyDetailsContainer';

const MAXMIND_DELAY = 500;

const Routes = ({
  client,
  setDefaultClientCountryCode,
  setDefaultClientTimezone,
  setUserLoginStatus,
  configureForMaintenanceMode,
  error,
}) => {
  useEffect(() => {
    configureForMaintenanceMode();
    setDefaultClientTimezone(client);
    setUserLoginStatus();

    // We need to be sure MaxMind has loaded.
    setTimeout(() => {
      setDefaultClientCountryCode(client);
    }, MAXMIND_DELAY);
  }, [
    client,
    configureForMaintenanceMode,
    setDefaultClientCountryCode,
    setDefaultClientTimezone,
    setUserLoginStatus,
  ]);

  return (
    <Router basename="/">
      <>
        {!!error.errors.length && (
          <Error message={error.errors[0].message} type={error.errors[0].type} />
        )}
        <Route component={CompanyDetailsContainer} path={steps.COMPANY_DETAILS.path} />
        <Route component={BookContainer} path={steps.BOOK.path} />
        <Route component={CreateAccountContainer} path={steps.CREATE_ACCOUNT.path} />
        <Route exact path="/" render={() => <Redirect to={steps.COMPANY_DETAILS.path} />} />
      </>
    </Router>
  );
};

Routes.propTypes = {
  client: PropTypes.object.isRequired,
  configureForMaintenanceMode: PropTypes.func.isRequired,
  error: PropTypes.object.isRequired,

  setDefaultClientCountryCode: PropTypes.func.isRequired,
  setDefaultClientTimezone: PropTypes.func.isRequired,
  setUserLoginStatus: PropTypes.func.isRequired,
};

export default Routes;
